import { createResourceApi } from '../../createResourceApi';
import { ApiPaths } from '../../apiPaths';

export const samlApi = createResourceApi(ApiPaths.SAML, (rest) => ({
  getIdp: (email: string) =>
    rest.get<string>({ path: 'okta_idp_id', config: { params: { email } } })
}));
